import Cookies from 'js-cookie';

export const gaClientID = () => {
  if (typeof window === 'undefined') return null;

  const value = Cookies.get('_ga');
  if (!value) return null;

  // GA1.2.123.456 -> 123.456
  return value.split('.').slice(2).join('.');
};
